<template lang="pug">
    div
        span.d-flex.align-center.justify-center.text-body-6
            | *Only one rule can be created per action. The drop down for 'rule action' will only show actions that have not already been created.
        v-form(ref="form" v-model="valid" @submit.prevent="handleSubmit")
            v-row
                v-col(cols="12" md="6")
                    v-text-field(
                        v-model.number="formData.metric"
                        label="Threshold"
                        type="number"
                        :rules="[v => !!v || 'Threshold is required']"
                        required
                        prepend-icon="mdi-percent"
                    )
                v-col(cols="12" md="6")
                    v-select(
                        v-model="formData.metric_unit"
                        :items="metricUnits"
                        label="Unit"
                        :rules="[v => !!v || 'Unit is required']"
                        required
                        :disabled="isEditMode"
                        prepend-icon="mdi-clock"
                    )
            v-row
                v-col(cols="6")
                    v-select(
                        :items="availableActions"
                        v-model="formData.rule_action"
                        label="Rule Action"
                        :rules="[v => ! !v || 'Rule Action is required']"
                        item-text="text"
                        item-value="value"
                        required
                        :disabled="isEditMode"
                        prepend-icon="mdi-alert"
                        no-data-text="All rules have already been created."
                    )
                v-col(cols="6")
                    v-select(
                        :items="colors"
                        v-model="formData.display_color"
                        label="Color"
                        :rules="[v => !!v || 'Color is required']"
                        required
                        item-text="text"
                        item-value="value"
                        prepend-icon="mdi-palette"
                    )
                        template(v-slot:selection="{ item }")
                            v-avatar(
                                :color="item.value"
                                size="12"
                                class="mr-2"
                            )
                            span {{ item.text }}
                        template(v-slot:item="{ item }")
                            v-avatar(
                                :color="item.value"
                                size="12"
                                class="mr-2"
                            )
                            span {{ item.text }}
            v-row
                v-col(cols="12" class="d-flex justify-end")
                    v-btn(
                        text
                        @click="$emit('cancel')"
                        class="mr-2"
                    ) Cancel
                    v-btn(
                        color="primary"
                        type="submit"
                        :disabled="!valid || isUpdateDisabled"  
                    ) {{ submitButtonText }}
</template>

<script>
import Vue from 'vue';

export default Vue.extend({

    data() {
        return {
            valid: false,
            availableActions: [],
            formData: {
                metric: null,
                metric_unit: null,
                rule_action: null,
                display_color: null,
                rule_id: null,
            },
            colors: [
                { text: 'Red', value: 'var(--error)' },
                { text: 'Orange', value: 'var(--orange)' },
            ],
            metricUnits: [
                { text: 'Seconds', value: 'seconds' },
                { text: 'Percentage', value: 'percentage' }
            ],
            ruleActions: [
                { text: 'Avg. inbound calls warning', value: 'ib_calls_warning' },
                { text: 'Avg. inbound calls critical', value: 'ib_calls_critical' },
                { text: 'Avg. outbound calls warning', value: 'ob_calls_warning' },
                { text: 'Avg. outbound calls critical', value: 'ob_calls_critical' },
                { text: 'Avg. hold duration warning', value: 'avg_hold_duration_warning' },
                { text: 'Avg. hold duration critical', value: 'avg_hold_duration_critical' },
                { text: 'Agent status warning', value: 'agent_status_warning_account' },
                { text: 'Agent status critical', value: 'agent_status_critical_account' },
            ]
        }
    },

    
    methods: {
        handleSubmit() {
                this.$emit('save', this.formData)
        },
        updateFilteredActions() {
            //If we're editing, need all actions to display disabled action - user will not be able to update this. 
            if (this.isEditMode) {
                this.availableActions = [...this.ruleActions];
                return;
            }
            
            // Initialize empty array for used actions
            const usedActions = [];
            
            //loop to collect actions from existing rules
            if (this.rules && this.rules.length > 0) {
                for (let i = 0; i < this.rules.length; i++) {
                    if (this.rules[i] && this.rules[i].rule_action) {
                        usedActions.push(this.rules[i].rule_action);
                    }
                }
            }
            
            
            // If no rules, make all actions available
            if (usedActions.length === 0) {
                this.availableActions = [...this.ruleActions];
                return;
            }
            
            // Filter available actions to only show actions that have not been used
            this.availableActions = this.ruleActions.filter(action => {
                return !usedActions.includes(action.value);
            });
            
        }
    },
    computed: {
        submitButtonText() {
            return this.mode === 'create' ? 'Create' : 'Update'
        },
        isEditMode() {
            return this.mode === 'edit'
        },
        isUpdateDisabled() {
            //check if any of the form fields have changed
            if (!this.rule && this.mode === 'edit') return true;
            
            return this.formData?.metric === this.rule?.metric &&
                this.formData?.metric_unit === this.rule?.metric_unit &&
                this.formData?.rule_action === this.rule?.rule_action &&
                this.formData?.display_color === this.rule?.display_color
        }
    },
    
    props: {
        mode: {
            type: String,
            required: true,
            validator: value => ['create', 'edit'].includes(value)
        },
        rule: {
            type: Object,
            default: () => null
        },
        rules: {
            type: Array,
            default: () => []
        }
    },

    watch: {
        rule: {
            immediate: true,
            
            handler(newVal) {
                if (newVal) {
                    this.formData = { ...newVal }
                }
            }
        },
        rules: {
            immediate: true,
            handler() {
                this.updateFilteredActions();
            }
        }
    },

    created() {
    },

    mounted() {
        this.$nextTick(() => {
        this.updateFilteredActions();
    });
        
    },

    destroyed() {
    }
})
</script>

<style lang="scss" scoped>
</style>
